/*
 * anaar & co. — product information tabs
 *
 * Roving-tabindex tablist following the WAI-ARIA authoring practices: only the
 * selected tab is in the tab sequence, and Arrow/Home/End move between tabs.
 * Selection follows focus, which is the expected behaviour for tab panels whose
 * content is already on the page.
 */
(function () {
  function initTabs(root) {
    if (root.dataset.anaarTabsReady === 'true') return;

    var list = root.querySelector('[role="tablist"]');
    if (!list) return;

    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    function select(tab, moveFocus) {
      tabs.forEach(function (candidate) {
        var selected = candidate === tab;
        var panel = document.getElementById(candidate.getAttribute('aria-controls'));

        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.setAttribute('tabindex', selected ? '0' : '-1');
        if (panel) panel.hidden = !selected;
      });

      if (moveFocus) tab.focus();
    }

    list.addEventListener('click', function (event) {
      var tab = event.target.closest('[role="tab"]');
      if (tab) select(tab, false);
    });

    list.addEventListener('keydown', function (event) {
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;

      var next = null;
      switch (event.key) {
        case 'ArrowRight':
          next = (current + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          next = (current - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      select(tabs[next], true);
    });

    root.dataset.anaarTabsReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-anaar-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Variant changes re-render the product form, so re-scan after section loads. */
  document.addEventListener('shopify:section:load', initAll);
})();
